<script>
export default {
    name: 'HereCircle',
    inject: ['map', 'ui', 'group'],
    props: {
        lat: {
            type: Number,
            required: true
        },
        lng: {
            type: Number,
            required: true
        },
        radius: {
            type: Number,
            required: true
        },
        strokeColor: {
            type: String,
            required: true
        },
        fillColor: {
            type: String,
            required: true
        },
    },
    data () {
        return {
            circle: null
        }
    },
    watch: {
        map: {
            handler: function (newVal) {
                if (null != newVal) {
                    this.createCircle()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.createCircle()
        })
    },
    updated () {
        if (null == this.circle) {
            this.createCircle()
        }
    },
    beforeDestroy () {
        this.removeCircle(false)
    },
    methods: {
        removeCircle (shouldUpdateState = true) {
            if (null == this.circle) return

            if (null == this.map() && null == this.group()) return

            const target = null != this.group() ? this.group() : this.map()
            if (null != target) {
                target.removeObject(this.circle)
            }

            if (shouldUpdateState) {
                this.circle = null
            }
        },
        instantiateCircle () {
            return new H.map.Circle({ lat: this.lat, lng: this.lng }, this.radius, {
                style: {
                    strokeColor: this.strokeColor,
                    lineWidth: 2,
                    fillColor: this.fillColor,
                }
            })
        },
        createCircle () {
            if (null == this.map() || null != this.circle) return null

            const circle = this.instantiateCircle()

            this.circle = circle

            const target = null != this.group() ? this.group() : this.map()

            target.addObject(circle)

            // this.map().addObject(marker)

            if (this.autoTap) {
                circle.dispatchEvent('tap')
            }

            return circle
        },
    },
    render () {
        return null
    }
}
</script>

<style scoped>

</style>
